import type { EnumEventTypes } from '@/constants/eventTypes.constants'

import { FieldClass, SectionsClass } from '@/api/fields'
import { request } from '@/utils/request'
export const refresh = async (field: FieldClass, listenerField: FieldClass, config: any, listener: any, sections: SectionsClass): Promise<FieldClass | FieldClass[] | undefined> => {
  const formData = new FormData()
  if (config?.__type) {
    formData.set('__type', config.__type)
  }

  formData.set('__id', config?.__uuid || '')
  formData.set('__action', config?.__action || '')
  formData.set('__name', field.name || '')
  formData.set('__adapter', field.refreshAdapter || config?.__adapter || '')
  if (sections.recordUuid) {
    formData.set('__recordUuid', sections.recordUuid)
  }

  const listenerFieldValue = listenerField.getValue()

  Object.keys(listenerFieldValue).forEach(key => {
    const rawValue = listenerFieldValue[key]
    const value = typeof rawValue === 'object' && rawValue !== null && 'value' in rawValue
      ? rawValue.value
      : rawValue
    formData.set(key, String(value))
  })

  const fieldValue = field.getValue()

  Object.keys(fieldValue).forEach(key => {
    const rawValue = fieldValue[key]
    const value = typeof rawValue === 'object' && rawValue !== null && 'value' in rawValue
      ? rawValue.value
      : rawValue
    formData.set(key, String(value))
  })

  if (listener && Array.isArray(listener.FieldsNames) && listener.FieldsNames.length) {
    listener.FieldsNames.forEach((fieldName: string) => {
      const _field = sections.getFieldByName(fieldName)
      const _value = _field?.value
      if (_value !== null && _value !== undefined && typeof _value !== 'object') {
        formData.set(fieldName, _value as string)
      }
    })
  }

  if (listener && Array.isArray(listener.Params?.FieldsToRefresh) && listener.Params?.FieldsToRefresh.length) {
    listener.Params?.FieldsToRefresh.forEach((fieldName: string) => {
      const _field = sections.getFieldByName(fieldName)

      // Попробую не пропускать объекты, ломался запрос (но данные нужные отправлялись)
      if (_field && _field.value !== null) {
        if (Array.isArray(_field.value)) {
          _field.value.forEach((val, index) => {
            formData.set(fieldName + '__' + index, val.Uuid || val.Bundle.Uuid)
          })
        } else {
          const value = (_field.value as Record<string, unknown>).value ?? _field.value
          formData.set(fieldName, String(value))
        }
      }
    })
  }

  const response = await request(field.refreshURL, {
    method: 'POST',
    body: formData,
  })

  if (response.data?.field) {
    const _field = new FieldClass(response.data.field)
    return _field
  } else if (response.data?.fields) {
    const fields = Object.values(response.data.fields)

    if (fields.length) {
      return fields.map(field => new FieldClass(field as import('@/types/serverField.type').IServerField))
    }
  }

  return undefined
}

export const dispatchFieldEvent = (field: FieldClass, uid: number | undefined, type: EnumEventTypes, opts?: { silent?: boolean }) => {
  const event = type + '-' + uid + '-' + field.name

  document.dispatchEvent(new CustomEvent(event, {
    detail: {
      field,
      event: type,
      silent: opts?.silent
    }
  }))
}

// Сохраняем прежний путь импорта для существующих компонентов.
export { getColParams } from '../Layout/utils'
